module.exports = __webpack_public_path__ + "static/media/sm.90073202.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sm.svg
// module id = 2210
// module chunks = 0